import { StyleParamType, wixColorParam, createStylesParams, wixFontParam } from '@wix/tpa-settings';
import type { ExtractStyleParamValue, StylesParamsType } from 'root/components/Menus/stylesParams';
import {
  Alignment,
  ExpandCollapseIcon,
  FeaturedBadgePlacement,
  FeaturedBadgeStyle,
  ModifiersListView,
  NavigationDropdownStyle,
  Placement,
  DividerType,
} from 'root/consts';
import { MIN_DOTS_SIZE } from './DesignSections/DotsDesign/consts';
import { LayoutStylesParams } from 'root/components/Menus/Settings/Tabs/LayoutTab/LayoutStylesParams';

type IMenusTabsNavigationStyleParams = {
  navigationTabsBackgroundColor: StyleParamType.Color;
  navigationTabsArrowsColor: StyleParamType.Color;
  navigationTabsBorderRadiusEndStart: StyleParamType.Number;
  navigationTabsBorderRadiusEndEnd: StyleParamType.Number;
  navigationTabsBorderRadiusStartStart: StyleParamType.Number;
  navigationTabsBorderRadiusStartEnd: StyleParamType.Number;
  navigationTabsTopBorderColor: StyleParamType.Color;
  navigationTabsStartBorderColor: StyleParamType.Color;
  navigationTabsEndBorderColor: StyleParamType.Color;
  navigationTabsBottomBorderColor: StyleParamType.Color;
  navigationTabsTopBorderWidth: StyleParamType.Number;
  navigationTabsStartBorderWidth: StyleParamType.Number;
  navigationTabsEndBorderWidth: StyleParamType.Number;
  navigationTabsBottomBorderWidth: StyleParamType.Number;
  navigationTabsTabColor: StyleParamType.Color;
  navigationTabsTabFont: StyleParamType.Font;
  navigationTabsTabBackgroundColor: StyleParamType.Color;
  navigationTabsTabBorderRadiusStartStart: StyleParamType.Number;
  navigationTabsTabBorderRadiusStartEnd: StyleParamType.Number;
  navigationTabsTabBorderRadiusEndStart: StyleParamType.Number;
  navigationTabsTabBorderRadiusEndEnd: StyleParamType.Number;
  navigationTabsTabTopBorderWidth: StyleParamType.Number;
  navigationTabsTabEndBorderWidth: StyleParamType.Number;
  navigationTabsTabStartBorderWidth: StyleParamType.Number;
  navigationTabsTabBottomBorderWidth: StyleParamType.Number;
  navigationTabsTabTopBorderColor: StyleParamType.Color;
  navigationTabsTabEndBorderColor: StyleParamType.Color;
  navigationTabsTabStartBorderColor: StyleParamType.Color;
  navigationTabsTabBottomBorderColor: StyleParamType.Color;
  navigationTabsSelectedColor: StyleParamType.Color;
  navigationTabsSelectedFont: StyleParamType.Font;
  navigationTabsSelectedBackgroundColor: StyleParamType.Color;
  navigationTabsSelectedBorderRadiusStartStart: StyleParamType.Number;
  navigationTabsSelectedBorderRadiusStartEnd: StyleParamType.Number;
  navigationTabsSelectedBorderRadiusEndStart: StyleParamType.Number;
  navigationTabsSelectedBorderRadiusEndEnd: StyleParamType.Number;
  navigationTabsSelectedTopBorderWidth: StyleParamType.Number;
  navigationTabsSelectedEndBorderWidth: StyleParamType.Number;
  navigationTabsSelectedStartBorderWidth: StyleParamType.Number;
  navigationTabsSelectedBottomBorderWidth: StyleParamType.Number;
  navigationTabsSelectedTopBorderColor: StyleParamType.Color;
  navigationTabsSelectedEndBorderColor: StyleParamType.Color;
  navigationTabsSelectedStartBorderColor: StyleParamType.Color;
  navigationTabsSelectedIndicatorColor: StyleParamType.Color;
};

export const navigationTabsStyleParams = createStylesParams<IMenusTabsNavigationStyleParams>({
  navigationTabsBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 0),
  },
  navigationTabsArrowsColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  navigationTabsBorderRadiusEndStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  navigationTabsBorderRadiusEndEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  navigationTabsBorderRadiusStartStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  navigationTabsBorderRadiusStartEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  navigationTabsTopBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  navigationTabsStartBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  navigationTabsEndBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  navigationTabsBottomBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  navigationTabsTopBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  navigationTabsStartBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  navigationTabsEndBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  navigationTabsBottomBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  navigationTabsTabColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  navigationTabsTabFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
    }),
  },
  navigationTabsTabBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 0),
  },
  navigationTabsTabBorderRadiusStartStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  navigationTabsTabBorderRadiusStartEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  navigationTabsTabBorderRadiusEndStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  navigationTabsTabBorderRadiusEndEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  navigationTabsTabTopBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  navigationTabsTabEndBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  navigationTabsTabStartBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  navigationTabsTabBottomBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  navigationTabsTabTopBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  navigationTabsTabEndBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  navigationTabsTabStartBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  navigationTabsTabBottomBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  navigationTabsSelectedColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  navigationTabsSelectedFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
    }),
  },
  navigationTabsSelectedBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 0),
  },
  navigationTabsSelectedBorderRadiusStartStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  navigationTabsSelectedBorderRadiusStartEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  navigationTabsSelectedBorderRadiusEndStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  navigationTabsSelectedBorderRadiusEndEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  navigationTabsSelectedTopBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  navigationTabsSelectedEndBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  navigationTabsSelectedStartBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  navigationTabsSelectedBottomBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 3,
  },
  navigationTabsSelectedTopBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  navigationTabsSelectedEndBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  navigationTabsSelectedStartBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  navigationTabsSelectedIndicatorColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
});

type IUnifiedNavigationStyleParams = {
  unifiedNavigationTabsBackgroundColor: StyleParamType.Color;
  unifiedNavigationTabsDividerColor: StyleParamType.Color;
  unifiedNavigationTabsBorderRadiusEndStart: StyleParamType.Number;
  unifiedNavigationTabsBorderRadiusEndEnd: StyleParamType.Number;
  unifiedNavigationTabsBorderRadiusStartStart: StyleParamType.Number;
  unifiedNavigationTabsBorderRadiusStartEnd: StyleParamType.Number;
  unifiedNavigationTabsTopBorderColor: StyleParamType.Color;
  unifiedNavigationTabsStartBorderColor: StyleParamType.Color;
  unifiedNavigationTabsEndBorderColor: StyleParamType.Color;
  unifiedNavigationTabsBottomBorderColor: StyleParamType.Color;
  unifiedNavigationTabsTopBorderWidth: StyleParamType.Number;
  unifiedNavigationTabsEndBorderWidth: StyleParamType.Number;
  unifiedNavigationTabsStartBorderWidth: StyleParamType.Number;
  unifiedNavigationTabsBottomBorderWidth: StyleParamType.Number;
};

export const unifiedNavigationStyleParams = createStylesParams<IUnifiedNavigationStyleParams>({
  unifiedNavigationTabsBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  unifiedNavigationTabsDividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  unifiedNavigationTabsBorderRadiusEndStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  unifiedNavigationTabsBorderRadiusEndEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  unifiedNavigationTabsBorderRadiusStartStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  unifiedNavigationTabsBorderRadiusStartEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  unifiedNavigationTabsTopBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  unifiedNavigationTabsStartBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  unifiedNavigationTabsEndBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  unifiedNavigationTabsBottomBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  unifiedNavigationTabsTopBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  unifiedNavigationTabsStartBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  unifiedNavigationTabsEndBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  unifiedNavigationTabsBottomBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
});
type ISectionTabsNavigationStyleParams = {
  sectionNavigationTabsArrowsColor: StyleParamType.Color;
  sectionNavigationTabsBorderRadiusEndStart: StyleParamType.Number;
  sectionNavigationTabsBorderRadiusEndEnd: StyleParamType.Number;
  sectionNavigationTabsBorderRadiusStartStart: StyleParamType.Number;
  sectionNavigationTabsBorderRadiusStartEnd: StyleParamType.Number;
  sectionNavigationTabsTopBorderColor: StyleParamType.Color;
  sectionNavigationTabsStartBorderColor: StyleParamType.Color;
  sectionNavigationTabsEndBorderColor: StyleParamType.Color;
  sectionNavigationTabsBottomBorderColor: StyleParamType.Color;
  sectionNavigationTabsTopBorderWidth: StyleParamType.Number;
  sectionNavigationTabsStartBorderWidth: StyleParamType.Number;
  sectionNavigationTabsEndBorderWidth: StyleParamType.Number;
  sectionNavigationTabsBottomBorderWidth: StyleParamType.Number;
  sectionNavigationTabsTabColor: StyleParamType.Color;
  sectionNavigationTabsTabFont: StyleParamType.Font;
  sectionNavigationTabsTabBackgroundColor: StyleParamType.Color;
  sectionNavigationTabsTabBorderRadiusStartStart: StyleParamType.Number;
  sectionNavigationTabsTabBorderRadiusStartEnd: StyleParamType.Number;
  sectionNavigationTabsTabBorderRadiusEndStart: StyleParamType.Number;
  sectionNavigationTabsTabBorderRadiusEndEnd: StyleParamType.Number;
  sectionNavigationTabsTabTopBorderWidth: StyleParamType.Number;
  sectionNavigationTabsTabEndBorderWidth: StyleParamType.Number;
  sectionNavigationTabsTabStartBorderWidth: StyleParamType.Number;
  sectionNavigationTabsTabBottomBorderWidth: StyleParamType.Number;
  sectionNavigationTabsTabTopBorderColor: StyleParamType.Color;
  sectionNavigationTabsTabEndBorderColor: StyleParamType.Color;
  sectionNavigationTabsTabStartBorderColor: StyleParamType.Color;
  sectionNavigationTabsTabBottomBorderColor: StyleParamType.Color;
  sectionNavigationTabsSelectedColor: StyleParamType.Color;
  sectionNavigationTabsSelectedFont: StyleParamType.Font;
  sectionNavigationTabsSelectedBackgroundColor: StyleParamType.Color;
  sectionNavigationTabsSelectedBorderRadiusStartStart: StyleParamType.Number;
  sectionNavigationTabsSelectedBorderRadiusStartEnd: StyleParamType.Number;
  sectionNavigationTabsSelectedBorderRadiusEndStart: StyleParamType.Number;
  sectionNavigationTabsSelectedBorderRadiusEndEnd: StyleParamType.Number;
  sectionNavigationTabsSelectedTopBorderWidth: StyleParamType.Number;
  sectionNavigationTabsSelectedEndBorderWidth: StyleParamType.Number;
  sectionNavigationTabsSelectedStartBorderWidth: StyleParamType.Number;
  sectionNavigationTabsSelectedBottomBorderWidth: StyleParamType.Number;
  sectionNavigationTabsSelectedTopBorderColor: StyleParamType.Color;
  sectionNavigationTabsSelectedEndBorderColor: StyleParamType.Color;
  sectionNavigationTabsSelectedStartBorderColor: StyleParamType.Color;
  sectionNavigationTabsSelectedIndicatorColor: StyleParamType.Color;
};
export const sectionTabsNavigationStyleParams = createStylesParams<ISectionTabsNavigationStyleParams>({
  sectionNavigationTabsArrowsColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  sectionNavigationTabsBorderRadiusEndStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionNavigationTabsBorderRadiusEndEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionNavigationTabsBorderRadiusStartStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionNavigationTabsBorderRadiusStartEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionNavigationTabsTopBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  sectionNavigationTabsStartBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  sectionNavigationTabsEndBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  sectionNavigationTabsBottomBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  sectionNavigationTabsTopBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionNavigationTabsStartBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionNavigationTabsEndBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionNavigationTabsBottomBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },

  sectionNavigationTabsTabColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  sectionNavigationTabsTabFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
    }),
  },
  sectionNavigationTabsTabBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 1),
  },
  sectionNavigationTabsTabBorderRadiusStartStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionNavigationTabsTabBorderRadiusStartEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionNavigationTabsTabBorderRadiusEndStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionNavigationTabsTabBorderRadiusEndEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionNavigationTabsTabTopBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionNavigationTabsTabEndBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionNavigationTabsTabStartBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionNavigationTabsTabBottomBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionNavigationTabsTabTopBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  sectionNavigationTabsTabEndBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  sectionNavigationTabsTabStartBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  sectionNavigationTabsTabBottomBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  sectionNavigationTabsSelectedColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  sectionNavigationTabsSelectedFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
      style: { bold: false, italic: false, underline: true },
    }),
  },
  sectionNavigationTabsSelectedBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 1),
  },
  sectionNavigationTabsSelectedBorderRadiusStartStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionNavigationTabsSelectedBorderRadiusStartEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionNavigationTabsSelectedBorderRadiusEndStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionNavigationTabsSelectedBorderRadiusEndEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionNavigationTabsSelectedTopBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionNavigationTabsSelectedEndBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionNavigationTabsSelectedStartBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionNavigationTabsSelectedBottomBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 3,
  },
  sectionNavigationTabsSelectedTopBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  sectionNavigationTabsSelectedEndBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  sectionNavigationTabsSelectedStartBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  sectionNavigationTabsSelectedIndicatorColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
  },
});

type IMenusNavigationDropdownStyleParams = {
  navigationDropdownStyle: StyleParamType.Number;
  navigationDropdownTextColor: StyleParamType.Color;
  navigationDropdownTextFont: StyleParamType.Font;
  navigationDropdownBackgroundColor: StyleParamType.Color;
  navigationDropdownBorderColor: StyleParamType.Color;
  navigationDropdownBorderWidth: StyleParamType.Number;
  navigationDropdownBorderRadius: StyleParamType.Number;
};

export const navigationDropdownStyleParams = createStylesParams<IMenusNavigationDropdownStyleParams>({
  navigationDropdownStyle: {
    type: StyleParamType.Number,
    getDefaultValue: () => NavigationDropdownStyle.Box,
  },
  navigationDropdownTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  navigationDropdownTextFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M'),
  },
  navigationDropdownBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  navigationDropdownBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  navigationDropdownBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  navigationDropdownBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
});

type IMenusNavigationStylesParams = IMenusTabsNavigationStyleParams & IMenusNavigationDropdownStyleParams;

export const menusNavigationStylesParams = {
  ...navigationTabsStyleParams,
  ...navigationDropdownStyleParams,
};

type ILocationsDropdownStyleParams = {
  locationsDropdownStyle: StyleParamType.Number;
  locationsDropdownTextColor: StyleParamType.Color;
  locationsDropdownTextFont: StyleParamType.Font;
  locationsDropdownBackgroundColor: StyleParamType.Color;
  locationsDropdownBorderColor: StyleParamType.Color;
  locationsDropdownBorderWidth: StyleParamType.Number;
  locationsDropdownBorderRadius: StyleParamType.Number;
};

export const locationsDropdownStyleParams = createStylesParams<ILocationsDropdownStyleParams>({
  locationsDropdownStyle: {
    type: StyleParamType.Number,
    getDefaultValue: () => NavigationDropdownStyle.Underline,
  },
  locationsDropdownTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  locationsDropdownTextFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M'),
  },
  locationsDropdownBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  locationsDropdownBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  locationsDropdownBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  locationsDropdownBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
});

type IMenusStylesParams = {
  menuBackgroundColor: StyleParamType.Color;
  menuBorderColorLeft: StyleParamType.Color;
  menuBorderColorTop: StyleParamType.Color;
  menuBorderColorRight: StyleParamType.Color;
  menuBorderColorBottom: StyleParamType.Color;
  menuBorderWidthLeft: StyleParamType.Number;
  menuBorderWidthTop: StyleParamType.Number;
  menuBorderWidthRight: StyleParamType.Number;
  menuBorderWidthBottom: StyleParamType.Number;
  menuBorderRadiusStartEnd: StyleParamType.Number;
  menuBorderRadiusStartStart: StyleParamType.Number;
  menuBorderRadiusEndEnd: StyleParamType.Number;
  menuBorderRadiusEndStart: StyleParamType.Number;
  menuTitleTheme: StyleParamType.Font;
  menuTitleColor: StyleParamType.Color;
  menuDescriptionTheme: StyleParamType.Font;
  menuDescriptionColor: StyleParamType.Color;
};

export const menusStylesParams = createStylesParams<IMenusStylesParams>({
  menuBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  menuBorderColorLeft: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  menuBorderColorTop: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  menuBorderColorRight: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  menuBorderColorBottom: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  menuBorderWidthLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  menuBorderWidthTop: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  menuBorderWidthRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  menuBorderWidthBottom: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  menuBorderRadiusStartEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  menuBorderRadiusStartStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  menuBorderRadiusEndEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  menuBorderRadiusEndStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  menuTitleTheme: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Page-title', {
      size: 32,
      htmlTag: 'h1',
    }),
  },
  menuTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  menuDescriptionTheme: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
      htmlTag: 'p',
    }),
  },
  menuDescriptionColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
});

type ISectionsStylesParams = {
  sectionBackgroundColor: StyleParamType.Color;
  sectionBorderColorLeft: StyleParamType.Color;
  sectionBorderColorRight: StyleParamType.Color;
  sectionBorderColorTop: StyleParamType.Color;
  sectionBorderColorBottom: StyleParamType.Color;
  sectionBorderWidthLeft: StyleParamType.Number;
  sectionBorderWidthRight: StyleParamType.Number;
  sectionBorderWidthTop: StyleParamType.Number;
  sectionBorderWidthBottom: StyleParamType.Number;
  sectionBorderRadiusStartEnd: StyleParamType.Number;
  sectionBorderRadiusStartStart: StyleParamType.Number;
  sectionBorderRadiusEndEnd: StyleParamType.Number;
  sectionBorderRadiusEndStart: StyleParamType.Number;
  sectionImageBorderRadiusStartEnd: StyleParamType.Number;
  sectionImageBorderRadiusStartStart: StyleParamType.Number;
  sectionImageBorderRadiusEndEnd: StyleParamType.Number;
  sectionImageBorderRadiusEndStart: StyleParamType.Number;
  sectionTitleTheme: StyleParamType.Font;
  sectionTitleColor: StyleParamType.Color;
  sectionDescriptionTheme: StyleParamType.Font;
  sectionDescriptionColor: StyleParamType.Color;
  sectionTopDividerWidth: StyleParamType.Number;
  sectionTopDividerColor: StyleParamType.Color;
  sectionBottomDividerWidth: StyleParamType.Number;
  sectionBottomDividerColor: StyleParamType.Color;
  sectionExpandCollapseIcon: StyleParamType.Number;
  sectionExpandCollapseIconSize: StyleParamType.Number;
  sectionTopDividerStyle: StyleParamType.Number;
  sectionBottomDividerStyle: StyleParamType.Number;
  sectionColumnDividerWidth: StyleParamType.Number;
  sectionColumnDividerColor: StyleParamType.Color;
};

export const sectionsStylesParams = createStylesParams<ISectionsStylesParams>({
  sectionBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 0),
  },
  sectionBorderColorLeft: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  sectionBorderColorRight: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  sectionBorderColorTop: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  sectionBorderColorBottom: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  sectionBorderWidthLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionBorderWidthRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionBorderWidthTop: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionBorderWidthBottom: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionBorderRadiusStartEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionBorderRadiusStartStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionBorderRadiusEndEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionBorderRadiusEndStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionImageBorderRadiusStartEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionImageBorderRadiusStartStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionImageBorderRadiusEndEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionImageBorderRadiusEndStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionTitleTheme: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Page-title', {
      size: 24,
      htmlTag: 'h2',
    }),
  },
  sectionTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  sectionDescriptionTheme: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
      htmlTag: 'p',
    }),
  },
  sectionDescriptionColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  sectionTopDividerWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  sectionTopDividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.3),
  },
  sectionBottomDividerWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  sectionBottomDividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.3),
  },
  sectionExpandCollapseIcon: {
    type: StyleParamType.Number,
    getDefaultValue: () => ExpandCollapseIcon.Chevron,
  },
  sectionExpandCollapseIconSize: {
    type: StyleParamType.Number,
    getDefaultValue: ({ isMobile }) => (isMobile ? 20 : 24),
  },
  sectionTopDividerStyle: {
    type: StyleParamType.Number,
    getDefaultValue: () => DividerType.Solid,
  },
  sectionBottomDividerStyle: {
    type: StyleParamType.Number,
    getDefaultValue: () => DividerType.Solid,
  },
  sectionColumnDividerWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  sectionColumnDividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
});

type IItemsStylesParams = {
  itemBackgroundColor: StyleParamType.Color;
  itemBorderColorLeft: StyleParamType.Color;
  itemBorderColorRight: StyleParamType.Color;
  itemBorderColorTop: StyleParamType.Color;
  itemBorderColorBottom: StyleParamType.Color;
  itemBorderWidthLeft: StyleParamType.Number;
  itemBorderWidthRight: StyleParamType.Number;
  itemBorderWidthTop: StyleParamType.Number;
  itemBorderWidthBottom: StyleParamType.Number;
  itemBorderRadiusStartEnd: StyleParamType.Number;
  itemBorderRadiusStartStart: StyleParamType.Number;
  itemBorderRadiusEndEnd: StyleParamType.Number;
  itemBorderRadiusEndStart: StyleParamType.Number;
  itemTitleTheme: StyleParamType.Font;
  itemTitleColor: StyleParamType.Color;
  itemDescriptionTheme: StyleParamType.Font;
  itemDescriptionColor: StyleParamType.Color;
  itemPriceTheme: StyleParamType.Font;
  itemPriceColor: StyleParamType.Color;
  itemImageRadiusStartEnd: StyleParamType.Number;
  itemImageRadiusStartStart: StyleParamType.Number;
  itemImageRadiusEndEnd: StyleParamType.Number;
  itemImageRadiusEndStart: StyleParamType.Number;
  itemDividerStyle: StyleParamType.Number;
  itemDividerColor: StyleParamType.Color;
  itemDividerWidth: StyleParamType.Number;
  itemGridDividerWidth: StyleParamType.Number;
  itemGridDividerColor: StyleParamType.Color;
};

export const itemsStylesParams = createStylesParams<IItemsStylesParams>({
  itemBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 0),
  },
  itemBorderColorLeft: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  itemBorderColorRight: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  itemBorderColorTop: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  itemBorderColorBottom: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  itemBorderWidthLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  itemBorderWidthRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  itemBorderWidthTop: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  itemBorderWidthBottom: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  itemBorderRadiusStartEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  itemBorderRadiusStartStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  itemBorderRadiusEndEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  itemBorderRadiusEndStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  itemTitleTheme: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Page-title', {
      size: 16,
      htmlTag: 'p',
    }),
  },
  itemTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  itemDescriptionTheme: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
      htmlTag: 'p',
    }),
  },
  itemDescriptionColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  itemPriceTheme: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
      htmlTag: 'p',
    }),
  },
  itemPriceColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  itemImageRadiusStartEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  itemImageRadiusStartStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  itemImageRadiusEndEnd: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  itemImageRadiusEndStart: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  itemDividerStyle: {
    type: StyleParamType.Number,
    getDefaultValue: () => DividerType.Solid,
  },
  itemDividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.3),
  },
  itemDividerWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  itemGridDividerWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  itemGridDividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.3),
  },
});

type IFeaturedItemStylesParams = {
  featuredItemTitleColor: StyleParamType.Color;
  featuredItemTitleTheme: StyleParamType.Font;
  featuredItemDescriptionColor: StyleParamType.Color;
  featuredItemDescriptionTheme: StyleParamType.Font;
  featuredItemPriceColor: StyleParamType.Color;
  featuredItemPriceTheme: StyleParamType.Font;
  featuredItemBackgroundColor: StyleParamType.Color;
  featuredItemBorderColorLeft: StyleParamType.Color;
  featuredItemBorderColorTop: StyleParamType.Color;
  featuredItemBorderColorRight: StyleParamType.Color;
  featuredItemBorderColorBottom: StyleParamType.Color;
  featuredItemBorderWidthLeft: StyleParamType.Number;
  featuredItemBorderWidthTop: StyleParamType.Number;
  featuredItemBorderWidthRight: StyleParamType.Number;
  featuredItemBorderWidthBottom: StyleParamType.Number;
  featuredItemBorderRadiusStartStart: StyleParamType.Number;
  featuredItemBorderRadiusStartEnd: StyleParamType.Number;
  featuredItemBorderRadiusEndStart: StyleParamType.Number;
  featuredItemBorderRadiusEndEnd: StyleParamType.Number;
  showFeaturedItemIcon: StyleParamType.Boolean;
  featuredItemIconColor: StyleParamType.Color;
  featuredItemIconSize: StyleParamType.Number;
  featuredItemIconPlacement: StyleParamType.Number;
  gridFeaturedItemPadding: StyleParamType.Number;
  columnsFeaturedItemPadding: StyleParamType.Number;
  sideBySideFeaturedItemPadding: StyleParamType.Number;
  centerFeaturedItemPadding: StyleParamType.Number;
  expandStripFeaturedItemPadding: StyleParamType.Number;
  expandCenterFeaturedItemPadding: StyleParamType.Number;
};

export const featuredItemStylesParams = createStylesParams<IFeaturedItemStylesParams>({
  featuredItemTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(itemsStylesParams.itemTitleColor),
  },
  featuredItemTitleTheme: {
    type: StyleParamType.Font,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(itemsStylesParams.itemTitleTheme),
  },
  featuredItemDescriptionColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(itemsStylesParams.itemDescriptionColor),
  },
  featuredItemDescriptionTheme: {
    type: StyleParamType.Font,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(itemsStylesParams.itemDescriptionTheme),
  },
  featuredItemPriceColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(itemsStylesParams.itemPriceColor),
  },
  featuredItemPriceTheme: {
    type: StyleParamType.Font,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(itemsStylesParams.itemPriceTheme),
  },
  featuredItemBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(itemsStylesParams.itemBackgroundColor),
  },
  featuredItemBorderColorLeft: {
    type: StyleParamType.Color,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(itemsStylesParams.itemBorderColorLeft),
  },
  featuredItemBorderColorRight: {
    type: StyleParamType.Color,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(itemsStylesParams.itemBorderColorRight),
  },
  featuredItemBorderColorTop: {
    type: StyleParamType.Color,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(itemsStylesParams.itemBorderColorTop),
  },
  featuredItemBorderColorBottom: {
    type: StyleParamType.Color,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(itemsStylesParams.itemBorderColorBottom),
  },
  featuredItemBorderWidthLeft: {
    type: StyleParamType.Number,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(itemsStylesParams.itemBorderWidthLeft),
  },
  featuredItemBorderWidthRight: {
    type: StyleParamType.Number,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(itemsStylesParams.itemBorderWidthRight),
  },
  featuredItemBorderWidthTop: {
    type: StyleParamType.Number,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(itemsStylesParams.itemBorderWidthTop),
  },
  featuredItemBorderWidthBottom: {
    type: StyleParamType.Number,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(itemsStylesParams.itemBorderWidthBottom),
  },
  featuredItemBorderRadiusStartStart: {
    type: StyleParamType.Number,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(itemsStylesParams.itemBorderRadiusStartStart),
  },
  featuredItemBorderRadiusStartEnd: {
    type: StyleParamType.Number,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(itemsStylesParams.itemBorderRadiusStartEnd),
  },
  featuredItemBorderRadiusEndStart: {
    type: StyleParamType.Number,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(itemsStylesParams.itemBorderRadiusEndStart),
  },
  featuredItemBorderRadiusEndEnd: {
    type: StyleParamType.Number,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(itemsStylesParams.itemBorderRadiusEndEnd),
  },
  showFeaturedItemIcon: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  featuredItemIconColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-6'),
  },
  featuredItemIconSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => 24,
  },
  featuredItemIconPlacement: {
    type: StyleParamType.Number,
    getDefaultValue: () => Placement.Before,
  },
  gridFeaturedItemPadding: {
    type: StyleParamType.Number,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(LayoutStylesParams.gridItemPadding),
  },
  columnsFeaturedItemPadding: {
    type: StyleParamType.Number,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(LayoutStylesParams.columnsItemPadding),
  },
  sideBySideFeaturedItemPadding: {
    type: StyleParamType.Number,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(LayoutStylesParams.sideBySideItemPadding),
  },
  centerFeaturedItemPadding: {
    type: StyleParamType.Number,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(LayoutStylesParams.centerItemPadding),
  },
  expandStripFeaturedItemPadding: {
    type: StyleParamType.Number,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(LayoutStylesParams.expandStripItemPadding),
  },
  expandCenterFeaturedItemPadding: {
    type: StyleParamType.Number,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(LayoutStylesParams.expandCenterItemPadding),
  },
});

type IMultiImagesStylesParams = {
  multiImagesBadgeTitleFont: StyleParamType.Font;
  multiImagesBadgeTitleColor: StyleParamType.Color;
  multiImagesBadgeBackgroundColor: StyleParamType.Color;
  multiImagesGalleryArrowColor: StyleParamType.Color;
};

export const multiImagesStylesParams = createStylesParams<IMultiImagesStylesParams>({
  multiImagesBadgeTitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 12,
      htmlTag: 'p',
    }),
  },
  multiImagesBadgeTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  multiImagesBadgeBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-3'),
  },
  multiImagesGalleryArrowColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
});

type IVariantsStylesParams = {
  variantTitleTheme: StyleParamType.Font;
  variantTitleColor: StyleParamType.Color;
  variantPriceTheme: StyleParamType.Font;
  variantPriceColor: StyleParamType.Color;
  variantDividerColor: StyleParamType.Color;
};

export const variantsStylesParams = createStylesParams<IVariantsStylesParams>({
  variantTitleTheme: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
      htmlTag: 'p',
    }),
  },
  variantTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  variantPriceTheme: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
      htmlTag: 'p',
    }),
  },
  variantPriceColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  variantDividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.3),
  },
});

type IModifiersStylesParams = {
  modifierGroupColor: StyleParamType.Color;
  modifierGroupTheme: StyleParamType.Font;
  modifierColor: StyleParamType.Color;
  modifierTheme: StyleParamType.Font;
  modifiersListView: StyleParamType.Number;
  modifierIconColor: StyleParamType.Color;
  showMoreModifiersColor: StyleParamType.Color;
  showMoreModifiersTheme: StyleParamType.Font;
  showMoreModifiersHoverColor: StyleParamType.Color;
  showMoreHoverBold: StyleParamType.Boolean;
  showMoreHoverItalic: StyleParamType.Boolean;
  showMoreHoverUnderline: StyleParamType.Boolean;
};

export const modifiersStylesParams = createStylesParams<IModifiersStylesParams>({
  modifierGroupColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  modifierGroupTheme: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
      htmlTag: 'p',
    }),
  },
  modifierColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  modifierTheme: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
      htmlTag: 'p',
    }),
  },
  modifiersListView: {
    type: StyleParamType.Number,
    getDefaultValue: () => ModifiersListView.Collapse,
  },
  modifierIconColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  showMoreModifiersColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  showMoreModifiersTheme: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
      htmlTag: 'p',
      style: {
        underline: true,
        italic: false,
        bold: false,
      },
    }),
  },
  showMoreModifiersHoverColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  showMoreHoverBold: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
  },
  showMoreHoverItalic: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
  },
  showMoreHoverUnderline: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
  },
});

type IDotsStylesParams = {
  dotsColor: StyleParamType.Color;
  dotsSize: StyleParamType.Number;
};

export const dotsStylesParams = createStylesParams<IDotsStylesParams>({
  dotsColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  dotsSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => MIN_DOTS_SIZE,
  },
});

type ILabelsStylesParams = {
  labelBackgroundColor: StyleParamType.Color;
  labelBorderColor: StyleParamType.Color;
  labelBorderWidth: StyleParamType.Number;
  labelBorderRadius: StyleParamType.Number;
  labelTitleTheme: StyleParamType.Font;
  labelTitleColor: StyleParamType.Color;
  labelIconColor: StyleParamType.Color;
  labelIconSize: StyleParamType.Number;
  labelSpaceBetween: StyleParamType.Number;
  labelVerticalPadding: StyleParamType.Number;
  labelHorizontalPadding: StyleParamType.Number;
};

export const labelsStylesParams = createStylesParams<ILabelsStylesParams>({
  labelBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  labelBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.1),
  },
  labelBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  labelBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 12,
  },
  labelTitleTheme: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 14,
    }),
  },
  labelTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  labelIconColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  labelIconSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
  },
  labelSpaceBetween: {
    type: StyleParamType.Number,
    getDefaultValue: () => 8,
  },
  labelVerticalPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  labelHorizontalPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 12,
  },
});

type IFeaturedBadgeStylesParams = {
  showFeaturedBadge: StyleParamType.Boolean;
  featuredBadgePlacement: StyleParamType.Number;
  featuredBadgeAlignment: StyleParamType.Number;
  featuredBadgeStyle: StyleParamType.Number;
  featuredBadgeBackgroundColor: StyleParamType.Color;
  featuredBadgeTextColor: StyleParamType.Color;
  featuredBadgeTextTheme: StyleParamType.Font;
  featuredBadgeBorderColor: StyleParamType.Color;
  featuredBadgeBorderWidth: StyleParamType.Number;
  featuredBadgeBorderRadius: StyleParamType.Number;
  featuredBadgeVerticalPadding: StyleParamType.Number;
  featuredBadgeHorizontalPadding: StyleParamType.Number;
};

export const featuredBadgeStylesParams = createStylesParams<IFeaturedBadgeStylesParams>({
  showFeaturedBadge: {
    type: StyleParamType.Boolean,
    getDefaultValue: ({ getStyleParamValue }) => getStyleParamValue(featuredItemStylesParams.showFeaturedItemIcon),
  },
  featuredBadgePlacement: {
    type: StyleParamType.Number,
    getDefaultValue: () => FeaturedBadgePlacement.ItemInfo,
  },
  featuredBadgeAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => Alignment.Start,
  },
  featuredBadgeStyle: {
    type: StyleParamType.Number,
    getDefaultValue: () => FeaturedBadgeStyle.Filled,
  },
  featuredBadgeBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  featuredBadgeTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  featuredBadgeTextTheme: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 14,
    }),
  },
  // The border starts fully transparent, so a badge only shows one once it is asked for.
  featuredBadgeBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 0),
  },
  featuredBadgeBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  featuredBadgeBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  featuredBadgeVerticalPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 2,
  },
  featuredBadgeHorizontalPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 6,
  },
});

export type IDesignStylesParams = IMenusNavigationStylesParams &
  IUnifiedNavigationStyleParams &
  ISectionTabsNavigationStyleParams &
  IMenusStylesParams &
  ISectionsStylesParams &
  IItemsStylesParams &
  IFeaturedItemStylesParams &
  IMultiImagesStylesParams &
  IVariantsStylesParams &
  IModifiersStylesParams &
  IDotsStylesParams &
  ILabelsStylesParams &
  IFeaturedBadgeStylesParams &
  ILocationsDropdownStyleParams;

export type DesignStylesParamsValues = {
  [K in keyof IDesignStylesParams]: ExtractStyleParamValue<(typeof DesignStylesParams)[K]>;
};

export const DesignStylesParams: StylesParamsType<IDesignStylesParams> = {
  ...locationsDropdownStyleParams,
  ...menusNavigationStylesParams,
  ...unifiedNavigationStyleParams,
  ...sectionTabsNavigationStyleParams,
  ...menusStylesParams,
  ...sectionsStylesParams,
  ...itemsStylesParams,
  ...featuredItemStylesParams,
  ...multiImagesStylesParams,
  ...variantsStylesParams,
  ...modifiersStylesParams,
  ...dotsStylesParams,
  ...labelsStylesParams,
  ...featuredBadgeStylesParams,
};
